import automaticControlCard from '@/assets/images/mechanical-hvac/automatic-control/automatic-control-card.webp';
import automaticControlBrochurePage14 from '@/assets/images/mechanical-hvac/automatic-control/brochure-page-14.webp';
import automaticControlComparisonGeneral03 from '@/assets/images/mechanical-hvac/automatic-control/custom-gallery/automatic-control-comparison-general-03.webp';
import automaticControlComparisonPremium04 from '@/assets/images/mechanical-hvac/automatic-control/custom-gallery/automatic-control-comparison-premium-04.webp';
import automaticControlDetailStage02 from '@/assets/images/mechanical-hvac/automatic-control/custom-gallery/automatic-control-detail-stage-02.webp';
import automaticControlPreview01 from '@/assets/images/mechanical-hvac/automatic-control/custom-gallery/automatic-control-preview-01.webp';
import automaticControlTimelineStage05 from '@/assets/images/mechanical-hvac/automatic-control/custom-gallery/automatic-control-timeline-stage-05.webp';
import automaticControlValueAfter07 from '@/assets/images/mechanical-hvac/automatic-control/custom-gallery/automatic-control-value-after-07.webp';
import automaticControlValueBefore06 from '@/assets/images/mechanical-hvac/automatic-control/custom-gallery/automatic-control-value-before-06.webp';
import boilerComparisonGeneral03 from '@/assets/images/mechanical-hvac/boiler/custom-gallery/boiler-comparison-general-03.webp';
import boilerComparisonPremium04 from '@/assets/images/mechanical-hvac/boiler/custom-gallery/boiler-comparison-premium-04.webp';
import boilerDetailStage02 from '@/assets/images/mechanical-hvac/boiler/custom-gallery/boiler-detail-stage-02.webp';
import boilerPreview01 from '@/assets/images/mechanical-hvac/boiler/custom-gallery/boiler-preview-01.webp';
import boilerPreview08 from '@/assets/images/mechanical-hvac/boiler/custom-gallery/boiler-preview-08.webp';
import boilerPreview09 from '@/assets/images/mechanical-hvac/boiler/custom-gallery/boiler-preview-09.webp';
import boilerTimelineStage05 from '@/assets/images/mechanical-hvac/boiler/custom-gallery/boiler-timeline-stage-05.webp';
import boilerValueAfter07 from '@/assets/images/mechanical-hvac/boiler/custom-gallery/boiler-value-after-07.webp';
import boilerValueBefore06 from '@/assets/images/mechanical-hvac/boiler/custom-gallery/boiler-value-before-06.webp';
import coolingTowerComparisonGeneral03 from '@/assets/images/mechanical-hvac/cooling-tower/custom-gallery/cooling-tower-comparison-general-03.webp';
import coolingTowerComparisonPremium04 from '@/assets/images/mechanical-hvac/cooling-tower/custom-gallery/cooling-tower-comparison-premium-04.webp';
import coolingTowerDetailStage02 from '@/assets/images/mechanical-hvac/cooling-tower/custom-gallery/cooling-tower-detail-stage-02.webp';
import coolingTowerPreview01 from '@/assets/images/mechanical-hvac/cooling-tower/custom-gallery/cooling-tower-preview-01.webp';
import coolingTowerPreview08 from '@/assets/images/mechanical-hvac/cooling-tower/custom-gallery/cooling-tower-preview-08.webp';
import coolingTowerPreview09 from '@/assets/images/mechanical-hvac/cooling-tower/custom-gallery/cooling-tower-preview-09.webp';
import coolingTowerTimelineStage05 from '@/assets/images/mechanical-hvac/cooling-tower/custom-gallery/cooling-tower-timeline-stage-05.webp';
import coolingTowerValueAfter07 from '@/assets/images/mechanical-hvac/cooling-tower/custom-gallery/cooling-tower-value-after-07.webp';
import coolingTowerValueBefore06 from '@/assets/images/mechanical-hvac/cooling-tower/custom-gallery/cooling-tower-value-before-06.webp';
import heatingCoolingBrochurePage10 from '@/assets/images/mechanical-hvac/heating-cooling/brochure-page-10.webp';
import heatingCoolingBrochurePage11 from '@/assets/images/mechanical-hvac/heating-cooling/brochure-page-11.webp';
import heatingCoolingComparisonGeneral03 from '@/assets/images/mechanical-hvac/heating-cooling/custom-gallery/heating-cooling-comparison-general-03.webp';
import heatingCoolingComparisonPremium04 from '@/assets/images/mechanical-hvac/heating-cooling/custom-gallery/heating-cooling-comparison-premium-04.webp';
import heatingCoolingDetailStage02 from '@/assets/images/mechanical-hvac/heating-cooling/custom-gallery/heating-cooling-detail-stage-02.webp';
import heatingCoolingPreview01 from '@/assets/images/mechanical-hvac/heating-cooling/custom-gallery/heating-cooling-preview-01.webp';
import heatingCoolingTimelineStage05 from '@/assets/images/mechanical-hvac/heating-cooling/custom-gallery/heating-cooling-timeline-stage-05.webp';
import heatingCoolingValueAfter07 from '@/assets/images/mechanical-hvac/heating-cooling/custom-gallery/heating-cooling-value-after-07.webp';
import heatingCoolingValueBefore06 from '@/assets/images/mechanical-hvac/heating-cooling/custom-gallery/heating-cooling-value-before-06.webp';
import heatingCoolingCard from '@/assets/images/mechanical-hvac/heating-cooling/heating-cooling-card.webp';
import hvacBrochurePage12 from '@/assets/images/mechanical-hvac/hvac/brochure-page-12.webp';
import hvacComparisonGeneral03 from '@/assets/images/mechanical-hvac/hvac/custom-gallery/hvac-comparison-general-03.webp';
import hvacComparisonPremium04 from '@/assets/images/mechanical-hvac/hvac/custom-gallery/hvac-comparison-premium-04.webp';
import hvacDetailStage02 from '@/assets/images/mechanical-hvac/hvac/custom-gallery/hvac-detail-stage-02.webp';
import hvacPreview01 from '@/assets/images/mechanical-hvac/hvac/custom-gallery/hvac-preview-01.webp';
import hvacPreview08 from '@/assets/images/mechanical-hvac/hvac/custom-gallery/hvac-preview-08.webp';
import hvacPreview09 from '@/assets/images/mechanical-hvac/hvac/custom-gallery/hvac-preview-09.webp';
import hvacTimelineStage05 from '@/assets/images/mechanical-hvac/hvac/custom-gallery/hvac-timeline-stage-05.webp';
import hvacValueAfter07 from '@/assets/images/mechanical-hvac/hvac/custom-gallery/hvac-value-after-07.webp';
import hvacValueBefore06 from '@/assets/images/mechanical-hvac/hvac/custom-gallery/hvac-value-before-06.webp';
import hvacCard from '@/assets/images/mechanical-hvac/hvac/hvac-card.webp';
import brochurePage09BusinessArea from '@/assets/images/mechanical-hvac/overview/brochure-page-09-business-area.webp';
import brochurePage17OperatingConsulting from '@/assets/images/mechanical-hvac/overview/brochure-page-17-operating-consulting.webp';
import operatingConsultingComparisonGeneral03 from '@/assets/images/mechanical-hvac/overview/custom-gallery/operating-consulting-comparison-general-03.webp';
import operatingConsultingComparisonPremium04 from '@/assets/images/mechanical-hvac/overview/custom-gallery/operating-consulting-comparison-premium-04.webp';
import operatingConsultingDetailStage02 from '@/assets/images/mechanical-hvac/overview/custom-gallery/operating-consulting-detail-stage-02.webp';
import operatingConsultingPreview01 from '@/assets/images/mechanical-hvac/overview/custom-gallery/operating-consulting-preview-01.webp';
import operatingConsultingPreview08 from '@/assets/images/mechanical-hvac/overview/custom-gallery/operating-consulting-preview-08.webp';
import operatingConsultingTimelineStage05 from '@/assets/images/mechanical-hvac/overview/custom-gallery/operating-consulting-timeline-stage-05.webp';
import operatingConsultingValueAfter07 from '@/assets/images/mechanical-hvac/overview/custom-gallery/operating-consulting-value-after-07.webp';
import operatingConsultingValueBefore06 from '@/assets/images/mechanical-hvac/overview/custom-gallery/operating-consulting-value-before-06.webp';
import operatingConsultingCard from '@/assets/images/mechanical-hvac/overview/operating-consulting-card.webp';
import plumbingBrochurePage13 from '@/assets/images/mechanical-hvac/plumbing/brochure-page-13.webp';
import plumbingComparisonGeneral03 from '@/assets/images/mechanical-hvac/plumbing/custom-gallery/plumbing-comparison-general-03.webp';
import plumbingComparisonPremium04 from '@/assets/images/mechanical-hvac/plumbing/custom-gallery/plumbing-comparison-premium-04.webp';
import plumbingDetailStage02 from '@/assets/images/mechanical-hvac/plumbing/custom-gallery/plumbing-detail-stage-02.webp';
import plumbingPreview01 from '@/assets/images/mechanical-hvac/plumbing/custom-gallery/plumbing-preview-01.webp';
import plumbingTimelineStage05 from '@/assets/images/mechanical-hvac/plumbing/custom-gallery/plumbing-timeline-stage-05.webp';
import plumbingValueAfter07 from '@/assets/images/mechanical-hvac/plumbing/custom-gallery/plumbing-value-after-07.webp';
import plumbingValueBefore06 from '@/assets/images/mechanical-hvac/plumbing/custom-gallery/plumbing-value-before-06.webp';
import plumbingCard from '@/assets/images/mechanical-hvac/plumbing/plumbing-card.webp';
import turboChillerComparisonGeneral03 from '@/assets/images/mechanical-hvac/turbo-chiller/custom-gallery/turbo-chiller-comparison-general-03.webp';
import turboChillerComparisonPremium04 from '@/assets/images/mechanical-hvac/turbo-chiller/custom-gallery/turbo-chiller-comparison-premium-04.webp';
import turboChillerDetailStage02 from '@/assets/images/mechanical-hvac/turbo-chiller/custom-gallery/turbo-chiller-detail-stage-02.webp';
import turboChillerPreview01 from '@/assets/images/mechanical-hvac/turbo-chiller/custom-gallery/turbo-chiller-preview-01.webp';
import turboChillerPreview08 from '@/assets/images/mechanical-hvac/turbo-chiller/custom-gallery/turbo-chiller-preview-08.webp';
import turboChillerPreview09 from '@/assets/images/mechanical-hvac/turbo-chiller/custom-gallery/turbo-chiller-preview-09.webp';
import turboChillerTimelineStage05 from '@/assets/images/mechanical-hvac/turbo-chiller/custom-gallery/turbo-chiller-timeline-stage-05.webp';
import turboChillerValueAfter07 from '@/assets/images/mechanical-hvac/turbo-chiller/custom-gallery/turbo-chiller-value-after-07.webp';
import turboChillerValueBefore06 from '@/assets/images/mechanical-hvac/turbo-chiller/custom-gallery/turbo-chiller-value-before-06.webp';

export const mechanicalHvacImages = {
  automaticControl: {
    card: automaticControlCard,
    brochurePage14: automaticControlBrochurePage14,
    customGallery: {
      comparisonGeneral03: automaticControlComparisonGeneral03,
      comparisonPremium04: automaticControlComparisonPremium04,
      detailStage02: automaticControlDetailStage02,
      preview01: automaticControlPreview01,
      timelineStage05: automaticControlTimelineStage05,
      valueAfter07: automaticControlValueAfter07,
      valueBefore06: automaticControlValueBefore06,
    },
  },
  boiler: {
    customGallery: {
      comparisonGeneral03: boilerComparisonGeneral03,
      comparisonPremium04: boilerComparisonPremium04,
      detailStage02: boilerDetailStage02,
      preview01: boilerPreview01,
      preview08: boilerPreview08,
      preview09: boilerPreview09,
      timelineStage05: boilerTimelineStage05,
      valueAfter07: boilerValueAfter07,
      valueBefore06: boilerValueBefore06,
    },
  },
  coolingTower: {
    customGallery: {
      comparisonGeneral03: coolingTowerComparisonGeneral03,
      comparisonPremium04: coolingTowerComparisonPremium04,
      detailStage02: coolingTowerDetailStage02,
      preview01: coolingTowerPreview01,
      preview08: coolingTowerPreview08,
      preview09: coolingTowerPreview09,
      timelineStage05: coolingTowerTimelineStage05,
      valueAfter07: coolingTowerValueAfter07,
      valueBefore06: coolingTowerValueBefore06,
    },
  },
  heatingCooling: {
    card: heatingCoolingCard,
    brochurePage10: heatingCoolingBrochurePage10,
    brochurePage11: heatingCoolingBrochurePage11,
    customGallery: {
      comparisonGeneral03: heatingCoolingComparisonGeneral03,
      comparisonPremium04: heatingCoolingComparisonPremium04,
      detailStage02: heatingCoolingDetailStage02,
      preview01: heatingCoolingPreview01,
      timelineStage05: heatingCoolingTimelineStage05,
      valueAfter07: heatingCoolingValueAfter07,
      valueBefore06: heatingCoolingValueBefore06,
    },
  },
  hvac: {
    card: hvacCard,
    brochurePage12: hvacBrochurePage12,
    customGallery: {
      comparisonGeneral03: hvacComparisonGeneral03,
      comparisonPremium04: hvacComparisonPremium04,
      detailStage02: hvacDetailStage02,
      preview01: hvacPreview01,
      preview08: hvacPreview08,
      preview09: hvacPreview09,
      timelineStage05: hvacTimelineStage05,
      valueAfter07: hvacValueAfter07,
      valueBefore06: hvacValueBefore06,
    },
  },
  overview: {
    card: operatingConsultingCard,
    brochurePage09BusinessArea,
    brochurePage17OperatingConsulting,
    customGallery: {
      comparisonGeneral03: operatingConsultingComparisonGeneral03,
      comparisonPremium04: operatingConsultingComparisonPremium04,
      detailStage02: operatingConsultingDetailStage02,
      preview01: operatingConsultingPreview01,
      preview08: operatingConsultingPreview08,
      timelineStage05: operatingConsultingTimelineStage05,
      valueAfter07: operatingConsultingValueAfter07,
      valueBefore06: operatingConsultingValueBefore06,
    },
  },
  plumbing: {
    card: plumbingCard,
    brochurePage13: plumbingBrochurePage13,
    customGallery: {
      comparisonGeneral03: plumbingComparisonGeneral03,
      comparisonPremium04: plumbingComparisonPremium04,
      detailStage02: plumbingDetailStage02,
      preview01: plumbingPreview01,
      timelineStage05: plumbingTimelineStage05,
      valueAfter07: plumbingValueAfter07,
      valueBefore06: plumbingValueBefore06,
    },
  },
  turboChiller: {
    customGallery: {
      comparisonGeneral03: turboChillerComparisonGeneral03,
      comparisonPremium04: turboChillerComparisonPremium04,
      detailStage02: turboChillerDetailStage02,
      preview01: turboChillerPreview01,
      preview08: turboChillerPreview08,
      preview09: turboChillerPreview09,
      timelineStage05: turboChillerTimelineStage05,
      valueAfter07: turboChillerValueAfter07,
      valueBefore06: turboChillerValueBefore06,
    },
  },
} as const;
